<template>
  <div :class="classes" :style="styles" @click="back">
    <slot>
      <div :class="innerClasses">
        <i class="ivu-icon ivu-icon-ios-arrow-up"></i>
      </div>
    </slot>
  </div>
</template>

<script>
const prefixCls = 'ivu-back-top';

export default {
  name: 'AppBackTop',
  props: {
    height: {
      type: Number,
      default: 400
    },
    bottom: {
      type: Number,
      default: 30
    },
    right: {
      type: Number,
      default: 30
    },
    duration: {
      type: Number,
      default: 400
    },
    target: {
      type: String,
      default: '#app'
    }
  },
  data() {
    return {
      backTop: false,
      scrollEl: null
    };
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-show`]: this.backTop
        }
      ];
    },
    styles() {
      return {
        bottom: `${this.bottom}px`,
        right: `${this.right}px`
      };
    },
    innerClasses() {
      return `${prefixCls}-inner`;
    }
  },
  watch: {
    target() {
      this.bindScrollTarget();
      this.$nextTick(() => {
        this.handleScroll();
      });
    }
  },
  mounted() {
    this.bindScrollTarget();
    this.handleScroll();
    window.addEventListener('resize', this.handleScroll);
  },
  beforeDestroy() {
    this.unbindScrollTarget();
    window.removeEventListener('resize', this.handleScroll);
  },
  methods: {
    getScrollTarget() {
      if (this.target && this.target !== 'window') {
        const el = document.querySelector(this.target);
        if (el) return el;
      }
      return window;
    },
    bindScrollTarget() {
      this.unbindScrollTarget();
      this.scrollEl = this.getScrollTarget();
      this.scrollEl.addEventListener('scroll', this.handleScroll);
    },
    unbindScrollTarget() {
      if (!this.scrollEl) return;
      this.scrollEl.removeEventListener('scroll', this.handleScroll);
      this.scrollEl = null;
    },
    getScrollTop() {
      if (this.scrollEl && this.scrollEl !== window) {
        return this.scrollEl.scrollTop || 0;
      }
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    setScrollTop(value) {
      if (this.scrollEl && this.scrollEl !== window) {
        this.scrollEl.scrollTop = value;
        return;
      }
      document.documentElement.scrollTop = value;
      document.body.scrollTop = value;
      window.scrollTo(0, value);
    },
    handleScroll() {
      this.backTop = this.getScrollTop() >= this.height;
    },
    back() {
      const start = this.getScrollTop();
      this.$emit('on-click');
      if (start <= 0) return;
      if (this.duration <= 0) {
        this.setScrollTop(0);
        return;
      }

      const startTime = (window.performance && typeof window.performance.now === 'function') ? window.performance.now() : Date.now();
      const step = now => {
        const progress = Math.min((now - startTime) / this.duration, 1);
        this.setScrollTop(Math.max(start * (1 - progress), 0));
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    }
  }
};
</script>
